module.exports = __webpack_public_path__ + "static/react-ed931db8893a909300aa1b8c2c81aab2.png";